<template>
  <QuestionPage :title="questionAnswerData.question">
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='lt-fyf-answer-eat-out-basic'
      :onSelect="chooseBasic"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='lt-fyf-answer-eat-out-medium'
      :onSelect="chooseMedium"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='lt-fyf-answer-eat-out-top'
      :onSelect="chooseTop"
    />
  </QuestionPage>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('eatout')
    }
  },
  methods: {
    ...mapMutations([
      'selectEatoutStatus',
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectEatoutStatus(1);
      this.goToItem('eatout');
    },
    chooseMedium: function () {
      this.selectEatoutStatus(2);
      this.goToItem('eatout');
    },
    chooseTop: function () {
      this.selectEatoutStatus(3);
      this.goToItem('eatout');
    }
  },
};
</script>

<style lang='scss'>
.lt-fyf-answer-eat-out-basic {
  background-image: url('../../assets/questions/eatout-minimum.jpg');
}
.lt-fyf-answer-eat-out-medium {
  background-image: url('../../assets/questions/eatout-moderate.jpg');
}
.lt-fyf-answer-eat-out-top {
  background-image: url('../../assets/questions/eatout-comfortable.jpg');
}
</style>